import {Component, NgZone, OnInit} from "@angular/core";;
import {ActivatedRoute, Router} from "@angular/router";
import {CarTemplateService} from "../car-template.service";
import {CarTemplateFilter} from "../model/car-template-filter";
import {CarTemplate} from "../model/car-template";
import {LoadingWheelService} from "../../../root/loading/loading-wheel.service";
import {SessionService} from "../../../core/session.service";
import {Page} from "../../../shared/pager/page";
import {GeoServiceA2} from "../../../core/geo_a2.service";
import {NotificationService} from "../../../root/toast/notification.service";
import {ModalService} from "../../../root/modal/modal.service";
import {TranslateService} from "@ngx-translate/core";
import {COMPANY_URL, CAR_TEMPLATE_URL, NEW_CAR_TEMPLATE_URL, APPROVAL_STATUS} from "../constants/car-template-constants";
import {PERM_CAR_TEMPLATE_MODERATE} from "../permissions/car-template-permissions";

@Component({
    selector: 'car-template-moderate',
    templateUrl: './car-template-moderate.component.html',
    providers: [CarTemplateService]
})
export class CarTemplateModerateComponent implements OnInit {

    CAR_TEMPLATE_TOAST_APPROVED_TITLE = 'carTemplate.toast.APPROVED_TITLE';
    CAR_TEMPLATE_TOAST_REJECTED_TITLE = 'carTemplate.toast.REJECTED_TITLE';
    CAR_TEMPLATE_TOAST_APPROVED_MESSAGE = 'carTemplate.toast.APPROVED_MESSAGE';
    CAR_TEMPLATE_TOAST_REJECTED_MESSAGE = 'carTemplate.toast.REJECTED_MESSAGE';
    CAR_TEMPLATE_REJECT_MODAL_TITLE = 'REJECT_CAR_TEMPLATE_TITLE';
    CAR_TEMPLATE_REJECT_MODAL_MESSAGE = 'REJECT_CAR_TEMPLATE_MESSAGE';

    lang:any;
    brands:any[];
    approvalStatus:any[];
    countries:any[];
    page:Page = new Page(10,1,0, []);
    carTemplateFilter: CarTemplateFilter = new CarTemplateFilter();

    constructor(private modalService:ModalService,
                private notificationService:NotificationService,
                private geoService:GeoServiceA2,
                private loading:LoadingWheelService,
                private route: Router,
                private activatedRoute: ActivatedRoute,
                private translate: TranslateService,
                private session:SessionService,
                private carTemplateService: CarTemplateService,
                private  zone: NgZone) {}

    ngOnInit() {
        this.lang = !!this.translate.currentLang ? this.translate.currentLang : 'es';
        this.loading.show();
        this.carTemplateFilter.approvalStatus = APPROVAL_STATUS.PENDING;
        this.activatedRoute.params.subscribe(params => {
            this.loadRequiredCollections();
            this.getCarTemplates();
        });
    }

    getCarTemplates() {
        this.loading.show();
        this.zone.run(() => {
            this.carTemplateService.getAll(this.carTemplateFilter,this.page.currentPage, this.page.itemsPerPage).subscribe(result => {
                    this.loadResultOnPage(result);
                    this.loading.hide();
            })
        });
    }

    onChange() {
        this.page.currentPage = 1;
        this.getCarTemplates();
    }

    onChangePage(event){
       this.page = event.page;
       this.getCarTemplates();
    }

    isLoading(){
       return this.loading.isLoading();
    }

    isModerationAllowed(carTemplate:CarTemplate){
        return this.session.loggedUserAllowed(PERM_CAR_TEMPLATE_MODERATE) && carTemplate.approvalStatus === APPROVAL_STATUS.PENDING;
    };

    isImageModerationAllowed(carTemplate:CarTemplate){
        return this.session.loggedUserAllowed(PERM_CAR_TEMPLATE_MODERATE) && carTemplate.approvalStatus === APPROVAL_STATUS.PENDING_IMAGE_VALIDATION;
    };

    moderate(carTemplate, status) {
        this.zone.run(() => {
            if (status === APPROVAL_STATUS.REJECTED) {
                this.modalService.show(this.CAR_TEMPLATE_REJECT_MODAL_TITLE, this.CAR_TEMPLATE_REJECT_MODAL_MESSAGE, () => {
                     this.carTemplateService.moderate(carTemplate, status).subscribe(response => {
                        this.moderateCallback(this.CAR_TEMPLATE_TOAST_REJECTED_TITLE, this.CAR_TEMPLATE_TOAST_REJECTED_MESSAGE, carTemplate);
                    });
                 });
            }

            if (status === APPROVAL_STATUS.APPROVED) {
                this.carTemplateService.moderate(carTemplate, status).subscribe(response => {
                         this.moderateCallback(this.CAR_TEMPLATE_TOAST_APPROVED_TITLE, this.CAR_TEMPLATE_TOAST_APPROVED_MESSAGE, carTemplate);
                });
            }
         });
    };

    approveModelPicture(carTemplate, status) {
        this.zone.run(() => {
                this.carTemplateService.moderateModelPicture(carTemplate, APPROVAL_STATUS.APPROVED).subscribe(response => {
                         this.moderateCallback(this.CAR_TEMPLATE_TOAST_APPROVED_TITLE, this.CAR_TEMPLATE_TOAST_APPROVED_MESSAGE, carTemplate);
                });
         });
    };

    private loadResultOnPage(result){
             this.page.currentPage = result.currentPage;
             this.page.numPages = Math.ceil(result.totalItems/result.itemsPerPage);
             this.page.pageItems = result.items;
    }

    private moderateCallback(title, message, carTemplate){
        this.notificationService.displayToast(title,message,  {"name": carTemplate.carModel.brand + "-" + carTemplate.carModel.model}, 'SUCCESS');
        this.ngOnInit();
    }

    private loadRequiredCollections() {
        this.zone.run(() => {
            this.carTemplateService.getAllApprovalStatus().subscribe(carApprovalStatus => {
                 this.approvalStatus = carApprovalStatus;
            });
            this.geoService.getCountries().subscribe(countries => {
                this.countries = countries
            });
         });
    }

     private showAuxPicture(carTemplate:CarTemplate) {
        return (carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_VALIDATION || (carTemplate.approvalStatus == APPROVAL_STATUS.PENDING_IMAGE_UPDATE));
     }
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/carTemplate/moderate/car-template-moderate.component.ts